import React from 'react';
import moment from 'moment';
import { Row, Col, Icon } from 'antd';
import lookup from 'country-code-lookup';
import { QUERY_University } from '../queries';
import { useQuery } from '@apollo/client';

function getCountryFromNationality(nationality) {
  if (!nationality || nationality === 'ZZZ') {
    return '-';
  }
  const countryInfo = lookup.byIso(nationality);
  return countryInfo?.country || '-';
}

const University = ({ slug }) => {
  const { data } = useQuery(QUERY_University, {
    variables: { slug },
  });
  const name = data?.university?.name;
  return <>{name ?? '-'}</>;
};

export default class StudentInfo extends React.Component {
  componentDidMount() {}

  render() {
    const { t, student, bookingData } = this.props;

    return (
      <div style={{ marginTop: '-16px' }}>
        <div className="longtail-booking-details__block-row-container">
          <div className="tipbox">
            <Icon type="info-circle" style={{ color: '#6B92F3', marginRight: '8px' }} />
            <div className="tipbox__content">
              This session shows booking details from the initial snapshot, while the top header
              updates in real-time via S.com.
            </div>
          </div>
          <Row gutter={50} className="longtail-booking-details__block-row">
            <Col span={12} className="longtail-booking-details__block-col">
              <p className="longtail-booking-details__line">
                {t('landlord.long_tail.booking_details.label.student_info.legal_first_name', {
                  value: student && student.passportFirstName ? student.passportFirstName : '-',
                })}
              </p>
              {/* `Legal ` + */}
              <p className="longtail-booking-details__line">
                {t('landlord.long_tail.booking_details.label.student_info.gender', {
                  value:
                    student && student.gender
                      ? t(
                          `landlord.long_tail.booking_details.field.gender.${student.gender.toLowerCase()}`,
                        )
                      : '-',
                })}
              </p>
              <p className="longtail-booking-details__line">{`Special Requirements:  ${
                student?.otherPreferences ?? '-'
              }`}</p>
            </Col>
            <Col span={12} className="longtail-booking-details__block-col">
              <p className="longtail-booking-details__line">
                {t('landlord.long_tail.booking_details.label.student_info.legal_last_name', {
                  value: student && student.passportLastName ? student.passportLastName : '-',
                })}
              </p>
              <p className="longtail-booking-details__line">
                {t('landlord.long_tail.booking_details.label.student_info.date_of_birth', {
                  value:
                    student && student.dateOfBirth
                      ? moment(student.dateOfBirth).format('DD/MM/YYYY')
                      : '-',
                })}
              </p>
            </Col>
          </Row>
        </div>
        <div className="longtail-booking-details__block-row-container">
          <Row gutter={50} className="longtail-booking-details__block-row">
            <Col span={12} className="longtail-booking-details__block-col">
              {/* ?.documentType?.value */}
              <p className="longtail-booking-details__line">{`Identification Type: ${
                student?.documentType || '-'
              }`}</p>
              <p className="longtail-booking-details__line">
                The School I am About to Attend:{' '}
                <University slug={student?.destinationUniversity} />
              </p>
              <p className="longtail-booking-details__line">
                {`Desired move-in Date: ${moment(bookingData.moveInDate).format('DD/MM/YYYY')}`}
              </p>
              <p className="longtail-booking-details__line">{`Nationality / Region: ${getCountryFromNationality(
                student?.nationality,
              )}`}</p>
            </Col>
            <Col span={12} className="longtail-booking-details__block-col">
              {/* ?.?.value */}
              <p className="longtail-booking-details__line">{`ID Number: ${
                student?.documentNumber || '-'
              }`}</p>
              <p className="longtail-booking-details__line">{`Degree: ${
                student?.studyMajor ?? '-'
              }`}</p>
              <p className="longtail-booking-details__line">{`Desired move-out Date: ${moment(
                bookingData.moveOutDate,
              ).format('DD/MM/YYYY')}`}</p>
            </Col>
          </Row>
        </div>
        <div className="longtail-booking-details__block-row-container">
          <Row gutter={50} className="longtail-booking-details__block-row">
            <Col span={12} className="longtail-booking-details__block-col">
              <p className="longtail-booking-details__line">
                {t('landlord.long_tail.booking_details.label.student_info.email', {
                  value: student && student.emailAddress ? student.emailAddress : '-',
                })}
              </p>
            </Col>
            <Col span={12} className="longtail-booking-details__block-col">
              <p className="longtail-booking-details__line">
                {t('landlord.long_tail.booking_details.label.student_info.mobile', {
                  value: student && student.phoneNumber ? student.phoneNumber : '-',
                })}
              </p>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}
